import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from "react-helmet"
import { config } from 'config'

export default class Index extends React.Component {
  render () {
    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "Sample"},
            {"name": "keywords", "content": "sample, something"},
          ]}
        />
        <p>

I am an experienced programmer with many languages that has recently been concentrating on javascript/node for the past 5+ years. .

I am now on a long time contract with http://nativeteachingaids.com/ doing web applications, Android, IOS, and PWA apps as well as node backends to support them.
    </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./index.js